// extracted by mini-css-extract-plugin
export default {"radio":"MGInputRadioButton_radio__Rw0+j","input":"MGInputRadioButton_input__tfKyw","visual":"MGInputRadioButton_visual__1m3vA","inner":"MGInputRadioButton_inner__K9e-v"};